import styled from 'styled-components'
import { Flex } from 'rebass'
import media from '../../../utils/style'

const FlexWrapper = styled(Flex)`
  align-items: center;
  justify-content: center;
  flex-direction: column;
  overflow: hidden;
  background-color: #eef4f9;
  padding-top: 40px;
  padding-bottom: 40px;

  ${media.MediumScreenUp`
    padding-top: 80px;
    padding-bottom: 80px;
  `}
`

export default FlexWrapper
